import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./hadith-header-style.css";
import { getNextPrayerTime } from "../../utils/prayer-times.service";

const HadithHeader = () => {
  const [time, setTime] = useState(new Date());
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();

  const [, setNextPrayer] = useState<any>(null);

  useEffect(() => {
    getNextPrayerTime().then((res) => {
      setNextPrayer(res);
    });

    const interval = setInterval(() => {
      getNextPrayerTime().then((res) => {
        setNextPrayer(res);
      });
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="header">
      <div style={{display: 'flex', flexDirection: 'column', justifyItems: 'center', alignItems: 'center', width: '100%'}}>
        <span className="timeText">
          {hours}:{minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
        {/* <span className="nextText">{nextPrayer}</span> */}
      </div>
      <Link type="submit" className="settings-holder" to={"/settings"}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            style={{ fill: "white" }}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2673 2.00049C12.9833 2.00049 13.6793 2.29449 14.1783 2.80549C14.6763 3.31949 14.9513 4.02449 14.9303 4.73949C14.9323 4.90049 14.9853 5.08649 15.0813 5.24949C15.2403 5.51949 15.4913 5.70949 15.7893 5.78749C16.0873 5.86149 16.3993 5.82149 16.6643 5.66449C17.9443 4.93349 19.5733 5.37149 20.3043 6.64149L20.9273 7.72049C20.9433 7.74949 20.9573 7.77749 20.9693 7.80649C21.6313 9.05749 21.1893 10.6325 19.9593 11.3515C19.7803 11.4545 19.6353 11.5985 19.5353 11.7725C19.3803 12.0415 19.3373 12.3615 19.4153 12.6555C19.4953 12.9555 19.6863 13.2045 19.9553 13.3585C20.5623 13.7075 21.0153 14.2955 21.1963 14.9745C21.3773 15.6525 21.2783 16.3885 20.9253 16.9955L20.2613 18.1015C19.5303 19.3575 17.9013 19.7925 16.6343 19.0605C16.4653 18.9635 16.2703 18.9105 16.0763 18.9055H16.0703C15.7813 18.9055 15.4843 19.0285 15.2683 19.2435C15.0493 19.4625 14.9293 19.7545 14.9313 20.0645C14.9243 21.5335 13.7293 22.7215 12.2673 22.7215H11.0143C9.54532 22.7215 8.35032 21.5275 8.35032 20.0585C8.34832 19.8775 8.29632 19.6895 8.19932 19.5265C8.04232 19.2525 7.78832 19.0565 7.49532 18.9785C7.20432 18.9005 6.88532 18.9435 6.62332 19.0955C5.99532 19.4455 5.25632 19.5305 4.58032 19.3405C3.90532 19.1495 3.32232 18.6855 2.98032 18.0705L2.35532 16.9935C1.62432 15.7255 2.05932 14.1005 3.32532 13.3685C3.68432 13.1615 3.90732 12.7755 3.90732 12.3615C3.90732 11.9475 3.68432 11.5605 3.32532 11.3535C2.05832 10.6175 1.62432 8.98849 2.35432 7.72049L3.03232 6.60749C3.75332 5.35349 5.38332 4.91149 6.65432 5.64149C6.82732 5.74449 7.01532 5.79649 7.20632 5.79849C7.82932 5.79849 8.35032 5.28449 8.36032 4.65249C8.35632 3.95549 8.63132 3.28649 9.13232 2.78149C9.63532 2.27749 10.3033 2.00049 11.0143 2.00049H12.2673ZM12.2673 3.50049H11.0143C10.7043 3.50049 10.4143 3.62149 10.1953 3.83949C9.97732 4.05849 9.85832 4.34949 9.86032 4.65949C9.83932 6.12149 8.64432 7.29849 7.19732 7.29849C6.73332 7.29349 6.28632 7.16849 5.89832 6.93649C5.35332 6.62649 4.64132 6.81749 4.32232 7.37249L3.64532 8.48549C3.33532 9.02349 3.52532 9.73449 4.07732 10.0555C4.89632 10.5295 5.40732 11.4135 5.40732 12.3615C5.40732 13.3095 4.89632 14.1925 4.07532 14.6675C3.52632 14.9855 3.33632 15.6925 3.65432 16.2425L4.28532 17.3305C4.44132 17.6115 4.69632 17.8145 4.99132 17.8975C5.28532 17.9795 5.60932 17.9445 5.87932 17.7945C6.27632 17.5615 6.73832 17.4405 7.20232 17.4405C7.43132 17.4405 7.66032 17.4695 7.88432 17.5295C8.56032 17.7115 9.14732 18.1635 9.49532 18.7705C9.72132 19.1515 9.84632 19.5965 9.85032 20.0505C9.85032 20.7005 10.3723 21.2215 11.0143 21.2215H12.2673C12.9063 21.2215 13.4283 20.7035 13.4313 20.0645C13.4273 19.3585 13.7033 18.6875 14.2083 18.1825C14.7063 17.6845 15.4023 17.3855 16.0983 17.4055C16.5543 17.4165 16.9933 17.5395 17.3803 17.7595C17.9373 18.0785 18.6483 17.8885 18.9703 17.3385L19.6343 16.2315C19.7823 15.9765 19.8253 15.6565 19.7463 15.3615C19.6683 15.0665 19.4723 14.8105 19.2083 14.6595C18.5903 14.3035 18.1493 13.7295 17.9663 13.0415C17.7853 12.3665 17.8843 11.6295 18.2373 11.0225C18.4673 10.6225 18.8043 10.2855 19.2083 10.0535C19.7503 9.73649 19.9403 9.02749 19.6253 8.47549C19.6123 8.45349 19.6003 8.43049 19.5903 8.40649L19.0043 7.39049C18.6853 6.83549 17.9753 6.64449 17.4183 6.96149C16.8163 7.31749 16.1003 7.41949 15.4123 7.23849C14.7253 7.06049 14.1493 6.62549 13.7903 6.01149C13.5603 5.62749 13.4353 5.18049 13.4313 4.72549C13.4403 4.38349 13.3203 4.07649 13.1023 3.85149C12.8853 3.62749 12.5803 3.50049 12.2673 3.50049ZM11.6452 8.97459C13.5122 8.97459 15.0312 10.4946 15.0312 12.3616C15.0312 14.2286 13.5122 15.7466 11.6452 15.7466C9.77822 15.7466 8.25922 14.2286 8.25922 12.3616C8.25922 10.4946 9.77822 8.97459 11.6452 8.97459ZM11.6452 10.4746C10.6052 10.4746 9.75922 11.3216 9.75922 12.3616C9.75922 13.4016 10.6052 14.2466 11.6452 14.2466C12.6852 14.2466 13.5312 13.4016 13.5312 12.3616C13.5312 11.3216 12.6852 10.4746 11.6452 10.4746Z"
          />
        </svg>
      </Link>
    </div>
  );
};

export default HadithHeader;
